import { flagByCurrency } from '@/constants/countries'
import { Currency } from '@/constants/currency'
import { getFlagUrl } from '@/lib/images'
import { formatCurrency } from '@/lib/money'

import { MotionSpan, Typography } from '../ui'

type Props = {
  currency?: Currency
}

export const CurrencyFlag = ({ currency = Currency.USDC }: Props) => {
  return (
    <div className="flex shrink-0 items-center gap-3">
      <img
        src={getFlagUrl(flagByCurrency[currency])}
        className="size-4"
        alt=""
        aria-hidden
      />
      <MotionSpan key={currency}>
        <Typography>{formatCurrency(currency)}</Typography>
      </MotionSpan>
    </div>
  )
}
